var map = {
	"./template.betprofessor": 1151,
	"./template.betprofessor.tsx": 1151,
	"./template.betroyale": 1152,
	"./template.betroyale.tsx": 1152,
	"./template.default": 661,
	"./template.default.tsx": 661,
	"./template.fiestabet": 1153,
	"./template.fiestabet.tsx": 1153,
	"./template.questbet": 1154,
	"./template.questbet.tsx": 1154,
	"./template.ts": 974,
	"./template.vikingbet": 1155,
	"./template.vikingbet.tsx": 1155,
	"./template.volcanobet": 1156,
	"./template.volcanobet.tsx": 1156,
	"./template.wellbet": 1157,
	"./template.wellbet.tsx": 1157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2428;